import { createStyles } from '@mantine/core';

import { Title } from '~/domains/design-system/Title';
import { Text } from '~/domains/design-system/Text';
import IconClipboard from '~/domains/design-system/icons/IconClipboard';
import dt from '~/testing';

const useStyles = createStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    flexGrow: 1,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    color: theme.colors.gray2[3],
    maxWidth: 350,
    textAlign: 'center',
  },
  iconContainer: {
    marginBottom: theme.other.spacing._16,
  },
}));

function EmptyStateMessage({
  icon,
  title,
  subtitle,
}: {
  icon?: JSX.Element;
  title: string | JSX.Element;
  subtitle: string | JSX.Element;
}) {
  const { classes, theme } = useStyles();

  return (
    <div
      data-test-id={dt.contest.quickPicks.detail.general.emptyStateQuickPicks}
      className={classes.container}
    >
      <div className={classes.content}>
        <div className={classes.iconContainer}>
          {icon ?? <IconClipboard color={theme.colors.gray2[3]} size={theme.other.spacing._48} />}
        </div>
        <Title variant="headline-xxl">{title}</Title>
        <Text variant="body-large">{subtitle}</Text>
      </div>
    </div>
  );
}

export default EmptyStateMessage;
